var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.logout}},[_vm._v(" Logout ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }